import React from 'react'
import { Button, Modal } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import storage from 'core/storage'
import { toJS } from 'mobx'
import { BREAK_STATUS_KEY } from 'core/constants'

const backBtn = {
  height: '60px',
  width: '250px',
  fontSize: 'x-large',
  display: 'block',
  margin: '0 auto',
}
class Break extends React.Component {
  state = {
    loading: false
  }

  handleBeforeUnload = (event) => {
    event.preventDefault()
    event.returnValue = 'Are you sure you want to leave? You are currently on break.'
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }

  leaveHandler = async() => {
    const { actions, store, history } = this.props
   

    store.account.online = false
    store.account.leave = false
    store.account.break = true

    // Save break status, token and account to localStorage
    storage.set(BREAK_STATUS_KEY, {
      isOnBreak: true,
      timestamp: Date.now(),
      token: store.token,
      account: toJS(store.account)
    })

    if(store.agent && store.agent.extraConversationsActive) {
      actions.agent.cancelMoreConversations()
    }

     // Add beforeunload event listener when going on break
    window.addEventListener('beforeunload', this.handleBeforeUnload)

    await actions.agent.leave()
    history.push('/break')
  }

  backHandler = async() => {
    const { actions, store, history } = this.props
    this.setState({ loading: true })
    await actions.agent.back()
    this.setState({ loading: false })
    store.account.online = true
    store.account.autoBreak = false
    store.account.break = false

     // Remove beforeunload event listener when coming back
     window.removeEventListener('beforeunload', this.handleBeforeUnload)
    // Clear break status from localStorage
    storage.remove(BREAK_STATUS_KEY)
    history.push('/')
  }

  renderLeaveConfirm = () => {
    const { store } = this.props

    return(
      <Modal size="small" open={store.account.leave} onClose={this.close}>
        <Modal.Content>
          <p>Are you sure you want to take a break?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => { store.account.leave = false }}>
            No
          </Button>
          <Button positive icon='sign out' labelPosition='right' content='Yes' onClick={this.leaveHandler}/>
        </Modal.Actions>
      </Modal>
    )
  }

  renderBack = () => {
    const { store } = this.props
    return(
      <Modal size="small" basic open={store.account.break || store.account.autoBreak} onClose={this.close}>
        <Modal.Content>
          { store.account.autoBreak && <p style={{margin: '15px auto', textAlign: 'center'}}>We have detected that you are away, we changed your status to offline</p>}
          <Button 
            loading={this.state.loading || store.conversations.length > 0} 
            disabled={this.state.loading || store.conversations.length > 0} 
            style={backBtn} 
            positive 
            icon='sign in' 
            labelPosition='right' 
            content="I'm back" 
            onClick={this.backHandler}
          />
        </Modal.Content>
      </Modal>
    )
  }

  render() {
    const { store } = this.props
    return (
      <div>
        { store.account.leave && this.renderLeaveConfirm() || store.account.autoBreak && this.renderBack() || store.account.break && this.renderBack() }
      </div>
    )
  }
}

export default withRouter(connect()(observer(Break)))
